import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './shared-component/guard/auth/auth.guard';
import { RouterGuardService } from './shared-component/guard/router-guard/router-guard.service';
import { LoanApplicationCustomerTCResolverService } from './shared-component/resolver/loanApplicationCustomerResolver/loan-application-customer-tc-resolver.service';
import { TermsConditionsBitlyComponent } from './terms-conditions-bitly/terms-conditions-bitly.component';
import { TermsConditionsAcceptedMessageComponent } from './terms-conditions-accepted-message/terms-conditions-accepted-message.component';


export const routes: Routes = [
  {
    path: 'loan/process/tc/:id',
    component: TermsConditionsBitlyComponent,
    resolve: {
      loanDetail: LoanApplicationCustomerTCResolverService
    }
  }, {
    path: 'message',
    component: TermsConditionsAcceptedMessageComponent,
  }, {
    path: ':partner/page',
    loadChildren: './partnerpage/partnerpage.module#PartnerPageModule'
  }, {
    path: 'loan/payment',
    loadChildren: './customer-payment/customer-payment.module#CustomerPaymentModule'
  }, {
    path: 'authentication',
    canActivate: [AuthGuard],
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  }, {
    path: 'application/process',
    loadChildren: './selfassisted/selfassisted.module#SelfAssistedModule'
  }, {
    path: 'loan/process',
    loadChildren: './bitly/bitly.module#BitlyModule'
  }, {
    path: 'loan/photo',
    loadChildren: './photo-upload/photo-upload.module#PhotoUploadModule'
  }, {
    path: 'loan/enach',
    loadChildren: './register-enach/register-enach.module#RegisterEnachModule'
  }, {
    path: 'loan/mandate',
    loadChildren: './second-mandate/second-mandate.module#SecondMandateModule'
  },{
    path: 'loan/tc',
    loadChildren: './second-esign/second-esign.module#SecondESignModule'
  },{
    path: 'application/ekyc',
    loadChildren: './second-ekyc/second-ekyc.module#SecondEkycModule'
  }, {
    path: 'tinyurl',
    loadChildren: './tinyurl/tinyurl.module#TinyUrlModule'
  }, {
    path: 'verify',
    loadChildren: './verification/verification.module#VerificationModule'
  },{
    path: 'error',
    loadChildren: './error/error.module#ErrorModule'
  }, {
    path: '',
    component: FullComponent,
    canActivate: [RouterGuardService],
    children: [
      { path: '', redirectTo: '/loans', pathMatch: 'full' },
      { path: 'loans', loadChildren: './loans/loans.module#LoansModule' },
      { path: 'application', loadChildren: './application/application.module#ApplicationModule' },
      { path: 'profile', loadChildren: './profile/profile.module#ProfileModule' },
      //{path: 'loanbooking', loadChildren: './loanBooking/loanBooking.module#LoanBookingModule'},
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }), NgbModule.forRoot()],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
